import type {ImportHondaRecallResult} from './ImportHondaRecallResultSchema';

export type ImportHondaRecallUseCaseResult = {
  result: ImportHondaRecallResult;
};
